const Stores = () => import(/* webpackChunkName: "vsf-inventory-sources" */ './pages/Stores.vue')
const Store = () => import(/* webpackChunkName: "vsf-inventory-sources" */ './pages/SingleStore.vue')

export default [
  { name: 'stores-index', path: '/store', component: Stores, props: { page: 'stores', title: 'Stores' } },
  { name: 'stores-show', path: '/store/:slug', component: Store, props: { page: 'store', title: 'View Store' } }
]
